<template>
	<div class="page-container">
		<div class="conteiner-fluid">
			<button id="addbRem" class="btn btn-info" @click="openForm"><i class="fa fa-plus"></i></button>
			<div class="tabla-contenedor">
				<table class="tabla-principal" id="EventsTable">
					<thead>
						<tr>
							<th v-for="col in columns" :key="col.key" :class="col.class">{{ col.label }}</th>
						</tr>
					</thead>
					<tbody v-if="is_loading">
						<td :colspan="columns.length" class="text-center" style="padding: 40px 0; border-bottom: 0;">
							<Loader :size="50" :margin="5" />
						</td>
					</tbody>
					<tbody v-else-if="eventsList.length == 0">
						<td :colspan="columns.length" class="text-center" style="padding: 60px 0;border-bottom: 0;">
							<h3>No Record</h3>
						</td>
					</tbody>
					<tbody v-else-if="eventsList.length > 0">
						<tr v-for="(eventItem, rowIndex) in paginatedRows" :key="eventItem.id"
							:class="{ selectedRow: selected.row === rowIndex }">
							<td v-for="(col, colIndex) in columns" :key="col.key" :class="[{
								selectedCell:
									selected.row === rowIndex &&
									selected.col === colIndex &&
									col.editable
							}, col.class]" @click="col.editable && selectCell(rowIndex, colIndex)">
								<template v-if="isEditingCell(rowIndex, colIndex, col)">
									<input ref="editableInput" v-model="eventsList[rowIndex][col.key]"
										@blur="stopEditing" @keydown.enter.prevent="stopEditing" class="cell-input" />
								</template>
								<template v-else>
									<div v-if="col.key == 'actions'">
										<DropdownMenu :buttonClass="['base', 'btn-actions']">
											<template v-slot:button>
												<i class="fas fa-ellipsis-v"></i>
											</template>
											<template v-slot:menu>
												<ul style="margin: 0; padding: 0; list-style: none">
													<li>
														<button>
															<i class="fas fa-edit"></i>
															Edit
														</button>
													</li>
													<li>
														<button class="text-left textAction">
															<i class="fas fa-times"></i>
															Delete
														</button>
													</li>
												</ul>
											</template>
										</DropdownMenu>
									</div>
									<idStartDate
										v-else-if="'id_note_date'==col.key"
										:eventData="eventItem"
										:note_number="eventItem.notes_count"
										:startDate="eventItem.event_date"
										@open-notes="openNote($event)"
									/>
									<div v-else-if="col.key == 'event_info'" class="event_info_content">
										<div class="profile_info" style="cursor: pointer;" @click="openForm(eventItem)">
											<div><strong style="color: #031099;">{{ eventItem.event_name }}</strong></div>
											<div>
												<span v-if="eventItem.address">{{eventItem.address}}</span><br />
												<span v-if="eventItem.city"> {{eventItem.city}}</span>
												<span v-if="eventItem.state">, {{eventItem.state}}</span>
												<span v-if="eventItem.zip"> {{eventItem.zip}}</span>
											</div>
										</div>
										<button class="btnOpen" @click="openForm(eventItem)"><i class="fas fa-expand-alt"></i></button>
									</div>
									<imgCover v-else-if="'imgCover'==col.key" :key="'imgCover'+eventItem.id"/>
									<sharingOps v-else-if="'sharing'==col.key" :shareOption="eventItem.shareValues" :eventData="eventItem" :key="'sharing'+eventItem.id"/>
									<delayTimer v-else-if="'delay'==col.key" :delay="eventItem.delay_timer" :eventData="eventItem" :key="'delay'+eventItem.id"/>
									<storageData v-else-if="'storage'==col.key" :key="'storage'+eventItem.id"/>
									<frameOps v-else-if="'photo_frame'==col.key"
										:captureMain="eventItem.captureValues"
										:eventData="eventItem"
										:key="'photo_frame'+eventItem.id"
										@show-background="openBackground"
									/>
									<linkEvent v-else-if="'link'==col.key" :key="'link'+eventItem.id"/>
									<div v-else>{{ eventItem[col.key] }}</div>
								</template>
							</td>
						</tr>
					</tbody>
					<tfoot style="display:none;">
						<tr>
							<td :colspan="columns.length" class="tfoot-control">
								<div class="tfoot-content">
									<div class="tfoot-item">
										Rows:
										<select v-model="rowsPerPage" @change="changeRowsPerPage">
											<option v-for="opt in [5, 10, 25, 50, 100]" :key="opt" :value="opt">
												{{ opt }}
											</option>
										</select>
									</div>
									<div class="tfoot-item">
										Page:
										<select v-model="currentPage">
											<option v-for="n in totalPages" :key="n" :value="n">
												{{ n }}
											</option>
										</select>
									</div>
									<div class="tfoot-item view-record">
										View {{ paginatedRows.length }} of {{ eventsList.length }}
									</div>
								</div>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
        <!-- modal background_photo-->
        <modal name="background_photo"
            height="auto"
            v-bind:click-to-close="true"
        >
            <div class="card">
            <div class="card-body">
                <button @click="$modal.hide('background_photo')" class="closeIcon" style=""><span></span></button>
                <h3>Choose your layout</h3>
                <BgUploader :eventData="eventSelected" @image-selected="backgroundUploader"/>
                <!-- <button @click="$modal.hide('background_photo')">Close</button> -->
            </div>
            </div>
        </modal>
        <!-- modal lateral-->
        <modalLateral>
            <component v-bind:is="m.component" ></component>
        </modalLateral>
	</div>
</template>
<script>
import axios from 'axios';
import { mapMultiGetters } from "@/core/utils/vuex";
import DropdownMenu from '@/core/components/DropdownMenu.vue'
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral';
import idStartDate from '../components/tEvent/idStartDate.vue';
import imgCover from '../components/tEvent/imgCover.vue';
import delayTimer from '../components/tEvent/delayTimer.vue';
import sharingOps from '../components/tEvent/sharingOps.vue';
import storageData from '../components/tEvent/storageData.vue';
import frameOps from '../components/tEvent/frameOps.vue';
import linkEvent from '../components/tEvent/linkEvent.vue';
import formEvents from '../components/formEvents.vue';
import eventNotes from '../components/eventNotes.vue';
import '../assets/tablebRemGeneral.scss';
import Loader from "../../../core/components/shared/Loader.vue";
import BgUploader from '../components/tEvent/BgUploader.vue';
export default {
	name: 'bRemDash',
	components: {
		DropdownMenu,
		modalLateral,
		idStartDate,
		imgCover,
		delayTimer,
		sharingOps,
		storageData,
		frameOps,
		linkEvent,
		formEvents,
		Loader,
		eventNotes,
		BgUploader,
	},
	data() {
		return {
			// @ts-ignore
			org_id: window.localorgdata,
			// @ts-ignore
			user_id: window.master_client,
			mainDropdownOpen: false,
			settingsDropdownOpen: false,
			columns: [
				{ key: "id_note_date", label: "#Id / Event Date", class: 'id_note_date', editable: false },
				{ key: "event_info", label: "Event Info", class: 'event_info', editable: false },
				{ key: "imgCover", label: "Cover", class: 'imgCover text-center', editable: false },
				{ key: "photo_frame", label: "Layout Options", class: 'photo_frame text-left', editable: false },
				{ key: "sharing", label: "Sharing", class: 'sharing text-center', editable: false },
				{ key: "delay", label: "Delay", class: 'delay ', editable: false },
				{ key: "storage", label: "Storage", class: 'storage ', editable: false },
				{ key: "link", label: 'Link', class: 'link ', editable: false },
			],
			selected: {
				row: null,
				col: null,
				editing: false
			},
			eventsList: [],
			rowsPerPage: 25,
			currentPage: 1,
            m: {
                show: false,
                component: '',
                data: []
            },
			urlGallery: null,
			userlist: [],
			pushPrjManager: 0,
			is_loading: false,
			eventSelected: null,
		};
	},
	computed: {
		...mapMultiGetters([
			["ModApps/bRem", {
				refresh_list: "get_refresh_list",
			}],
			["core", {
				getPusher: "get_accitonPusher",
				getOpenModal: "getOpenModal",
				returnModalRefresh: "getActionRefresh",
			}]
		]),
		totalPages() {
			return Math.ceil(this.eventsList.length / this.rowsPerPage);
		},
		paginatedRows() {
			const start = (this.currentPage - 1) * this.rowsPerPage;
			const end = start + this.rowsPerPage;
			return this.eventsList.slice(start, end);
		}
	},
	created() {
			this.getbRem();
	},
	mounted() {
	},
	methods: {
		getbRem() {
			let t = this;
			t.is_loading = true;
				// @ts-ignore
			window.master.post('bRem/getEvents', {
				org_id: this.org_id,
				user_id: this.user_id,
				rows_page: this.rowsPerPage,
			})
			.then((response) => {
				t.is_loading = false;
				console.log('bRem loaded', response.data);
				this.$store.commit("ModApps/bRem/set_finished", response.data.eventFinished);
				this.$store.commit("ModApps/bRem/set_pending", response.data.eventPending);
				this.urlGallery = response.data.url_folder;
				this.eventsList = response.data.list.data.map(eventItem => ({
					...eventItem,
					id_note_date: '',
					event_info: '',
					imgCover: '',
					photo_frame: '',
					sharing: '',
					delay: '',
					storage: '',
					link: '',
					currentType: eventItem.current_type.name,
					shareValues: (eventItem.event_share) ? JSON.parse(eventItem.event_share) : [],
					captureValues: (eventItem.event_capture) ? JSON.parse(eventItem.event_capture) : [],
				}));
				console.log('eventsList', t.eventsList);
			}).catch((error) => {
				t.is_loading = false;
				console.log(error);
			});
		},
		selectCell(rowIndex, colIndex) {
			this.selected.row = rowIndex;
			this.selected.col = colIndex;
			this.selected.editing = true;

			this.$nextTick(() => {
				const input = this.$refs.editableInput;
				if (input && input[0]) {
					input[0].focus();
					input[0].select();
				}
			});
		},
		isEditingCell(row, colIndex, column) {
			return (
				column.editable &&
				this.selected.row === row &&
				this.selected.col === colIndex &&
				this.selected.editing
			);
		},
		stopEditing() {
			this.selected.row = null;
			this.selected.col = null;
			this.selected.editing = false;
		},
		changeRowsPerPage() {
			this.currentPage = 1; // volver a la primera página
		},
		openForm(dataItem){
			this.m = {
				show: true,
				component: 'formEvents',
				data: dataItem ?? null
			};
			this.$store.commit('core/setOpenModal', this.m);
		},
		openNote(dataItem){
			this.m = {
				show: true,
				component: 'eventNotes',
				data: {event_id: dataItem}
			};
			this.$store.commit('core/setOpenModal', this.m);
		},
		getUsersList() {
			let t = this;
			let colors = t.$store.getters['core/get_paletaDeColores'];
			let url = "/users/" + window.master_client;
			window.master.post('usersListSec', {
				user_id: window.master_client,
				org_id: window.localorgdata,
			})
			.then((response) => {
				let r = response.data;
				t.userlist = [{
					id: r.org.id,
					account_id: r.org.account_id,
					owner: r.org.bill_company_name,
					firstname: r.org.bill_firstname,
					lastname: r.org.bill_lastname,
					email: r.org.bill_email,
					pref_name: r.org.pref_name + ' ' + r.org.pref_lastname,
					pref_email: r.org.pref_email,
					classColor: (r.org.color) ? ((r.org.color != '') ? (r.org.color) : '#031099') : '#031099',
					avatar: null,
				}];
				for (let i in r.users) {
					if (r.users[i]) {
						t.userlist.push({
							id: r.users[i].id,
							account_id: r.users[i].account_id,
							owner: r.org.bill_email,
							firstname: r.users[i].firstname,
							lastname: r.users[i].lastname,
							email: r.users[i].email,
							pref_name: r.users[i].pref_name + ' ' + r.users[i].pref_lastname,
							pref_email: r.users[i].pref_email,
							classColor: (r.users[i].color) ? ((r.users[i].color != '') ? (r.users[i].color) : colors[i]) : colors[i],
							avatar: (r.users[i].avatar) ? r.users[i].ruta + r.users[i].avatar : null,
						});
					}
				}
				//console.log('usersListSec', t.userlist)
			})
			.catch((error) => {
				console.log(error);
			});
		},
		printManager(i){
			return this.userlist.find(r => { return r.account_id == i.prj_manager});
		},
		openBackground(payload){
			this.eventSelected = payload;
			this.$modal.show('background_photo');
		},
		backgroundUploader(file) {
			let t = this;
			t.is_loading = true;
				// @ts-ignore
			/*axios.post(url, payload, {
				headers: {
					common: {
						Authorization: 'Bearer ' + window.localtoken_M
					},
					post: { 'Content-Type': 'multipart/form-data' }
				},
				onUploadProgress: (progressEvent) => {
					// console.log('onUploadProgress', progressEvent)
					let scanPer = Math.floor(
						(progressEvent.loaded * 100 / progressEvent.total)
					);
					// console.log('scanPer', scanPer);
					context.commit('set_ploadProgress', scanPer);
				}
			})
				.then((response) => {
					console.log(url, response.data);
				}).catch((error) => {
					console.log(error);
				});*/
		},
	},
	watch: {
		refresh_list(newVal, oldVal) {
			if (newVal != oldVal) {
				this.getbRem();
			}
		},
		getOpenModal(newVal) {
			this.m = newVal;
		},
		getPusher: function(){
            let t = this;
            if (t.getPusher != undefined) {
				console.log('Pusher bRem', t.getPusher);
                // let token = localStorage.getItem('access_token_m');
                // let oauth_m = localStorage.getItem('oauth_m');
                // if(t.getPusher.action == "tablebRem" && t.getPusher.data.org_id == window.localorgdata){
				// 	if(t.getPusher.data.action=="setPrjManager"){
				// 		console.log(t.getPusher.data.action, t.getPusher.data);
				// 		let manager = this.printManager(t.getPusher.data)
				// 		console.log('manager', manager)
				// 		this.$set(t.eventsList.find(r => { return r.sale_id == t.getPusher.data.sale_id}), 'manager', manager);
				// 		this.$set(t.eventsList.find(r => { return r.sale_id == t.getPusher.data.sale_id}), 'prj_manager', t.getPusher.data.prj_manager);
				// 		this.pushPrjManager++;
				// 	}
                // }
            }
        },
	}
};
</script>
<style scoped lang="scss">
@import '../assets/tablebRem.scss';
</style>
